import { ConfigProvider, message } from 'antd'
import viVN from 'antd/es/locale/vi_VN'
import axios from 'axios'
import { createBrowserHistory } from 'history'
import { Provider } from 'mobx-react'
import 'mobx-react-lite/batchingForReactDom'
import moment from 'moment'
import 'moment/locale/vi'
import React, { useEffect, useRef, useState } from 'react'
import { Redirect, Route, Router, Switch } from 'react-router-dom'
import './App.less'
import LoadingSpinner from './components/LoadingSpinner'
import Report from './components/MainSidebar/Report'
import { useSSO, apiUrl } from './config'
import { ensureValidToken, initKeycloak, onTokenUpdate } from './keycloak'
import contentTemplateStore from './pages/ContentTemplate/contentTemplateStore'
import DashboardPageV2 from './pages/DashboardPageV2'
import DemoTagPage from './pages/Demo/index'
import isoDocumentStore from './pages/ISODocumentPage/isoDocumentStore'
import resourcesStore from './pages/MyDocumentPage/ResourcesStore'
import kpiQuarterPageStore from './pages/KpiQuarterPage/KpiQuarterPageStore'
import listHistoryLogStore from './pages/ListHistoryLog/ListHistoryLogStore'
import NotFoundPage from './pages/NotFoundPage'
import ThemeProvider from './providers/ThemeProvider'
import { normalRoutes, routes } from './routes'
import accountEditStore from './stores/accountEditStore'
import accountStore from './stores/accountStore'
import aclStore from './stores/aclStore'
import actionStore from './stores/actionStore'
import approvalTemplateStore from './stores/approvalTemplateStore'
import authenticationStore from './stores/authenticationStore'
import authorityStore from './stores/authorityStore'
import bookStore from './stores/bookStore'
import chamCongStore from './stores/chamCongStore'
import chatBotStore from './stores/chatBotStore'
import chuTruongCommentStore from './stores/chuTruongCommentStore'
import chuTruongStore from './stores/chuTruongStore'
import commandStore from './stores/commandStore'
import commonServiceStore from './stores/commonServiceStore'
import commonStore from './stores/commonStore'
import companyStore from './stores/companyStore'
import connectedCommitteeDocumentStore from './stores/connectedCommitteeDocumentStore'
import connectedDocumentStore from './stores/connectedDocumentStore'
import consultCommentStore from './stores/consultCommentStore'
import consultStore from './stores/ConsultStore'
import departmentStore from './stores/departmentStore'
import DistributionVotesStore from './stores/DistributionVotesStore'
import documentAccessibilityStore from './stores/documentAccessibilityStore'
import documentStore from './stores/documentStore'
import electronicDocumentStore from './stores/electronicDocumentStore'
import fileStore from './stores/fileStore'
import internalDocumentStore from './stores/internalDocumentStore'
import internalMessageStore from './stores/internalMessageStore'
import kpiStore from './stores/kpiStore'
import leavePageStore from './stores/leavePageStore'
import loadingAnimationStore from './stores/loadingAnimationStore'
import managementAssetWarehouseStore from './stores/managementAssetWarehouseStore'
import managerInventoryStore from './stores/managerInventoryStore'
import messagesStore from './stores/messagesStore'
import moduleStore from './stores/moduleStore'
import notificationStore from './stores/notificationStore'
import organizationStore from './stores/organizationStore'
import payslipStore from './stores/payslipStore'
import phieuTrinhFakeDataStore from './stores/phieuTrinhFakeDataStore'
import positionStore from './stores/positionStore'
import proposalAdvanceStore from './stores/proposalAdvanceStore'
import proposalSalaryStore from './stores/proposalSalaryStore'
import proposalStore from './stores/proposalStore'
import proposalTypeStore from './stores/proposalTypeStore'
import reportStore from './stores/reportStore'
import riskUnitStore from './stores/risk/riskUnitStore'
import riskUnitUserStore from './stores/risk/riskUnitUserStore'
import riskAriseStore from './stores/riskAriseStore'
import riskStore from './stores/riskStore'
import riskTemplateStore from './stores/riskTemplateStore'
import roleStore from './stores/roleStore'
import salaryStore from './stores/salaryStore'
import sampleDocumentStore from './stores/sampleDocumentStore'
import selectPeopleStore from './stores/selectPeopleStore'
import selectUserStore from './stores/selectUserStore'
import ShoppingCouponStore from './stores/ShoppingCouponStore'
import signAccountStore from './stores/signAccountStore'
import signedDocumentStore from './stores/signedDocumentStore'
import staffStore from './stores/staffStore'
import statisticStore from './stores/statisticStore'
import taskManagementCommentStore from './stores/taskManagementCommentStore'
import taskManagementStore from './stores/taskManagementStore'
import taskStore from './stores/taskStore'
import timesheetsStore from './stores/timesheetsStore'
import tintucStore from './stores/tintucStore'
import userGroupStore from './stores/userGroupStore'
import userStore from './stores/userStore'
import userTrucStore from './stores/userTrucStore'
import voteStore from './stores/voteStore'
import workScheduleStore from './stores/workScheduleStore'
import workStore from './stores/workStore'

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem('jwt') || sessionStorage.getItem('jwt') ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: '/login', state: { from: props.location } }}
        />
      )
    }
  />
)

const history = createBrowserHistory()

const rootStore = {
  loadingAnimationStore,
  commonStore,
  authenticationStore,
  userStore,
  userGroupStore,
  commandStore,
  companyStore,
  accountStore,
  accountEditStore,
  positionStore,
  notificationStore,
  departmentStore,
  connectedDocumentStore,
  internalDocumentStore,
  connectedCommitteeDocumentStore,
  fileStore,
  authorityStore,
  bookStore,
  staffStore,
  workScheduleStore,
  taskManagementStore,
  sampleDocumentStore,
  roleStore,
  taskManagementCommentStore,
  statisticStore,
  organizationStore,
  documentStore,
  leavePageStore,
  phieuTrinhFakeDataStore,
  timesheetsStore,
  chamCongStore,
  payslipStore,
  proposalStore,
  proposalTypeStore,
  approvalTemplateStore,
  riskTemplateStore,
  riskAriseStore,
  taskStore,
  selectUserStore,
  consultStore,
  consultCommentStore,
  signedDocumentStore,
  signAccountStore,
  tintucStore,
  workStore,
  managerInventoryStore,
  chuTruongCommentStore,
  chuTruongStore,
  electronicDocumentStore,
  selectPeopleStore,
  messagesStore,
  internalMessageStore,
  userTrucStore,
  kpiQuarterPageStore,
  kpiStore,
  salaryStore,
  aclStore,
  commonServiceStore,
  moduleStore,
  proposalAdvanceStore,
  proposalSalaryStore,
  listHistoryLogStore,
  isoDocumentStore,
  resourcesStore,
  contentTemplateStore,
  documentAccessibilityStore,
  voteStore,
  riskStore,
  actionStore,
  reportStore,
  riskUnitUserStore,
  riskUnitStore,
  DistributionVotesStore,
  managementAssetWarehouseStore,
  chatBotStore,
  ShoppingCouponStore,
}

axios.defaults.timeout = 60 * 60 * 1000
axios.interceptors.request.use(
  async config => {
    if (!useSSO || config?.skipAuthRefresh || !config?.url?.includes(apiUrl))
      return config

    const refreshedToken = await ensureValidToken()
    if (!refreshedToken) return config

    saveToken(refreshedToken)

    const currentAuthorization =
      config?.headers?.Authorization || config?.headers?.authorization

    if (
      !currentAuthorization ||
      (typeof currentAuthorization === 'string' &&
        currentAuthorization.startsWith('Bearer '))
    ) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${refreshedToken}`,
      }
    }

    return config
  },
  error => Promise.reject(error)
)
axios.interceptors.response.use(
  response => response,
  async error => {
    if (axios.isCancel(error)) return Promise.resolve()
    const originalRequest = error?.config
    const originalAuthorization =
      originalRequest?.headers?.Authorization ||
      originalRequest?.headers?.authorization

    if (
      useSSO &&
      !originalRequest?.skipAuthRefresh &&
      error?.response?.status === 401 &&
      typeof originalAuthorization === 'string' &&
      originalAuthorization.startsWith('Bearer ') &&
      !originalRequest?._retry
    ) {
      originalRequest._retry = true
      try {
        const refreshedToken = await ensureValidToken({
          minValiditySeconds: 0,
          forceRefresh: true,
        })

        if (refreshedToken) {
          saveToken(refreshedToken)
          originalRequest.headers = {
            ...originalRequest.headers,
            Authorization: `Bearer ${refreshedToken}`,
          }
          return axios(originalRequest)
        }
      } catch (refreshError) {
        console.error('Refresh token after 401 failed', refreshError)
      }
    }

    if (error?.response?.status === 408 || error?.code === 'ECONNABORTED') {
      message.config({ maxCount: 1 })
      message.error('Request timeout!')
      authenticationStore.userLogout()
      history.push('/login')
    }
    var errorMessage = error?.response?.data?.errorMessage?.messages
    if (errorMessage) {
      errorMessage.errorCode = error?.response?.data?.errorMessage?.errorCode
    }
    return Promise.reject(
      errorMessage || { vi: 'Đã có lỗi xảy ra trong quá trình kết nối!' }
    )
  }
)

moment.locale('vi', { week: { dow: 1 } })

function saveToken(tokenValue) {
  if (tokenValue) {
    try {
      const currentToken = JSON.parse(authenticationStore.appToken || '{}')
        ?.access_token
      if (currentToken === tokenValue) return
    } catch (_error) {
      // Continue and overwrite malformed token payload
    }

    const objToken = { access_token: tokenValue }
    localStorage.setItem('jwt', JSON.stringify(objToken))
    authenticationStore.setAppToken(JSON.stringify(objToken))
  }
}

const App = () => {
  const [token, setToken] = useState(null)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let isMounted = true

    if (!useSSO) {
      if (isMounted) {
        setReady(true)
      }
      return
    }

    // Lắng nghe token update (refresh)
    const unsubscribeTokenUpdate = onTokenUpdate(newToken => {
      if (!isMounted) return
      saveToken(newToken)
    })

    // Khởi động manual PKCE flow
    initKeycloak().then(accessToken => {
      if (isMounted && accessToken) {
        const browserLocation = `${window.location.pathname}${window.location.search}${window.location.hash}`
        const routerLocation = `${history.location.pathname}${history.location.search}${history.location.hash}`
        if (routerLocation !== browserLocation) {
          history.replace(browserLocation)
        }

        setToken(accessToken)
        saveToken(accessToken)
        setReady(true)
      }
      // Nếu null → đang redirect sang login, không cần làm gì
    })

    return () => {
      isMounted = false
      if (unsubscribeTokenUpdate) {
        unsubscribeTokenUpdate()
      }
    }
  }, [])

  if (!ready) return <p />

  return <AppRouter token={token} />
}

export const AppRouter = ({ token }) => {
  const currentToken = useSSO ? token : authenticationStore.appToken
  const isAuthenticated = Boolean(currentToken)
  const didBootstrapRef = useRef(false)

  useEffect(() => {
    console.log('useSSO', useSSO, process.env.REACT_APP_USE_SSO)
  }, [])

  useEffect(() => {
    if (!isAuthenticated || didBootstrapRef.current) return
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        const { data } = await authenticationStore.checkCurrentUser()
        await Promise.all([
          aclStore.getACLDetailByUser(data.username),
          commandStore.getCommandList(),
          accountStore.getCurrentUserAccount(),
          moduleStore.getModuleList(),
          companyStore.getCompanyList(),
        ])
        didBootstrapRef.current = true
      } catch (err) {
        if (authenticationStore.currentUser) {
          console.error(
            'Skip forced logout after background token refresh',
            err
          )
          return
        }

        console.error(
          'Không tìm thấy user trong hệ thống, đang đăng xuất...',
          err
        )
        if (useSSO) {
          message.error({
            content: 'Tài khoản chưa được đăng ký trên hệ thống!',
            duration: 2,
          })
        } else {
          localStorage.clear()
          history.push('/login')
        }
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [isAuthenticated])

  useEffect(() => {
    if (!isAuthenticated) return
    ;(async () => {
      try {
        await Promise.allSettled([
          userStore.getMentionUserList(),
          notificationStore.getUnreadNotificationCount(),
          notificationStore.getUnreadNewsCount(),
          authenticationStore.getCurrentUserAvatar(),
        ])
      } catch (err) {
        console.log(err)
      }
    })()
  }, [isAuthenticated])

  return (
    <Provider {...rootStore}>
      <ThemeProvider>
        <ConfigProvider locale={viVN}>
          <Router history={history}>
            <Switch>
              {normalRoutes.map(route => (
                <Route
                  key={route.path}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}
              <ProtectedRoute exact path={'/'} component={DashboardPageV2} />
              <ProtectedRoute
                exact
                path={'/dashboard'}
                component={DashboardPageV2}
              />
              {routes.map(route => (
                <ProtectedRoute
                  key={route.path}
                  exact
                  path={route.path}
                  component={route.component}
                />
              ))}
              <ProtectedRoute exact path={'/demo'} component={DemoTagPage} />
              <Route component={NotFoundPage} />
            </Switch>
          </Router>
        </ConfigProvider>
        <LoadingSpinner />
        <div
          style={{
            position: 'fixed',
            top: 17,
            right: 10,
            zIndex: 10000000001,
          }}>
          <Report />
        </div>
      </ThemeProvider>
    </Provider>
  )
}

export default App
